// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
import React from 'react'
// import PropTypes from 'prop-types'
import { css } from 'glamor'
import isUndefined from 'lodash/isUndefined'

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
import Division from '@bodhi-project/components/lib/Division'

import '@bodhi-project/antrd/lib/se-concern-lwes-type/3.10.0/row/style/css'
import '@bodhi-project/antrd/lib/se-concern-lwes-type/3.10.0/col/style/css'

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals
import NewInteractiveImages from './NewInteractiveImages'

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions
const { Fragment } = React

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/** InfoBox */
class InfoBox extends React.Component {
  /** standard constructor */
  constructor(props) {
    super(props)

    this.state = {
      currentIndex: undefined,
    }

    this.setActive = this.setActive.bind(this)
  }

  /** setActive */
  setActive(index) {
    this.setState({
      currentIndex: index,
    })
  }

  /** standard renderer */
  render() {
    const {
      data,
      display,
      activeStyle = {
        border: '2px solid rgba(255, 201, 0, 1)',
        borderRadius: 12,
        background: 'rgba(255, 238, 171, 1)',
      },
      inactiveStyle = {
        border: '2px solid rgba(255, 201, 0, 0)',
        borderRadius: 12,
        background: 'rgba(255, 243, 196, 1)',
      },
      withDivision = true,
      columns = { min: 3, max: 3 },
      divisionProps = { goldenAlt: true },
      mobileViewer = false,
      defaultIndex,
    } = this.props

    const { currentIndex } = this.state
    const activeIndex = isUndefined(currentIndex) ? defaultIndex : currentIndex
    const Info = display[activeIndex].info

    const activeClass = css({
      '& .react-photo-gallery--gallery': {
        '& > div': {
          '& > div': {
            ...inactiveStyle,
            cursor: 'pointer',
          },
          [`& > div:nth-child(${activeIndex + 1})`]: {
            cursor: 'pointer',
            ...activeStyle,
          },
        },
      },
    }).toString()

    return (
      <Fragment>
        {withDivision === true ? (
          <Division {...divisionProps}>
            <div className={activeClass}>
              <NewInteractiveImages
                data={data}
                lookup="icon"
                setActive={this.setActive}
                columns={columns}
                mobileViewer={mobileViewer}
              />
            </div>
            <div>
              <Info />
            </div>
          </Division>
        ) : (
          <div className={activeClass}>
            <NewInteractiveImages
              data={data}
              lookup="icon"
              setActive={this.setActive}
              columns={columns}
              mobileViewer={mobileViewer}
            />
            <Info />
          </div>
        )}
      </Fragment>
    )
  }
}

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Export
// ----------------------------------------------------------------------------
export default InfoBox
